import moment from 'moment';

import { FLIGHT_PERIODS } from 'components/FlightsSearch/components/FlightTimePicker/constants';
import { TimeOption } from 'components/FlightsSearch/components/FlightTimePicker/models';

export const convertTimeString = (date: Date): string => {
  let hh = date.getHours();
  const min = date.getMinutes();
  let period = 'AM';
  if (hh > 12) {
    hh -= 12;
    period = 'PM';
  } else if (hh === 0) {
    hh = 12;
  } else if (hh === 12) {
    period = 'PM';
  }

  return `${twoDigits(hh)}:${twoDigits(min)} ${period}`;
};

const twoDigits = (n: number): string => (n < 10 ? `0${n}` : `${n}`);

// convert from AM / PM to 24h
export const convertTime24h = (time: string): string => {
  let res = '';
  const aux = time.split(' ');
  const aux2 = aux[0].split(':');
  const hh = aux2[0];
  const mm = aux2[1];
  let nH = Number(hh);
  if (aux[1] === 'PM') {
    nH = nH === 12 ? nH : nH + 12;
  } else {
    nH = nH === 12 ? 0 : nH;
  }
  res = `${twoDigits(nH)}:${mm}`;
  return res;
};

export const dateToString = (date: Date | string): string => moment(date).format('YYYY-MM-DDTHH:mm:00.000');

export const compareDates = (dt1?: Date, dt2?: Date) => {
  if (typeof dt1 === 'undefined' || typeof dt2 === 'undefined') return false;
  const strDt1 = dt1 ? dateToString(dt1) : '';
  const strDt2 = dt2 ? dateToString(dt2) : '';
  return strDt1 === strDt2;
};

export const setHours = (date: Date, hours: string): Date => {
  if (typeof date === 'string') date = new Date(date);
  const time = convertTime24h(hours).split(':');
  if (date && time && date.setHours) {
    date.setHours(Number(time[0]), Number(time[1]), 0, 0);
  }
  return date;
};

export const convertTime = (time?: TimeOption): string => {
  if (time === undefined || time === null) return '00:00:00';
  if (time.value.indexOf('AM') > -1 || time.value.indexOf('PM') > -1) {
    return `${convertTime24h(time.value)}:00`;
  }
  const period = FLIGHT_PERIODS.find((f) => f.value === time.value);
  if (period && period.hour) return period.hour;
  return '00:00:00';
};
